import { useState, useEffect, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { Button, Form, Input, Select, DatePicker, Table, Spin } from "antd";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { getAdminLocation } from '../../redux/actions/adminLocation.action';
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { ReadCookie } from "../../utils/readCookie";
import { getCreditOpenInvoice } from "../../redux/actions/CreditOpenInvoiceDetailReport.action copy"
import moment from "moment";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const { Option } = Select;
const CreditOpenInvoicedetailReport = () => {
  TabTitle("Credit Open Invoice")
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const [toogle, setToogle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [creditOpenDetailList, setCreditOpenDetailList] = useState([]);
  const [excelData, setExcelData] = useState([])
  const submitButton = useRef(null);
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const { adminLocation, creditOpenInvoice } = useSelector((state) => state);
  const queryParams = new URLSearchParams(window.location.search);
  const customerID = queryParams.get("customer_id");
  const companyId = ReadCookie("defaultCompany");


  useEffect(() => {
    dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);

  const indexedData = useMemo(() => {
    return creditOpenDetailList?.map((item, i, all) => {
      const filteredSoFar = all.slice(0, i).filter(r => r.return_header_no === 0);
      return {
        ...item,
        customIndex: item.return_header_no > 0 ? '' : filteredSoFar.length + 1,
      };
    }) || [];
  }, [creditOpenDetailList]);

  const BDCols = [
    {
      title: '#',
      dataIndex: 'customIndex',
      key: 'customIndex',
      width: 50,
    },
    {
      title: 'SKU',
      dataIndex: 'parent_item_code',
      key: 'parent_item_code',
      width: 70,
    },
    {
      title: 'Inseam',
      dataIndex: 'inseam',
      key: 'inseam',
      width: 80,
      align: "center",
      render: (text, record, index) => record.inseam === null ? "N/A" : record.inseam
    },
    {
      title: 'Customer',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150,
    },
    {
      title: 'Billing Addressee',
      dataIndex: 'billing_addressee',
      key: 'billing_addressee',
      width: 150,
    },
    {
      title: 'Billing City',
      dataIndex: 'billing_city',
      key: 'billing_city',
      width: 150,
    },
    {
      title: 'Shipping City',
      dataIndex: 'shipping_city',
      key: 'shipping_city',
      width: 150,
    },
    {
      title: 'Invoice #',
      dataIndex: 'invoice_header_no',
      key: 'invoice_header_no',
      width: 80,
      render: (text, record) => (
        <Link style={{ color: "#0d6efd", textDecoration: "underline" }}
          target="_blank"
          to={"/invoice?mode=edit&order_header_id=" + record.order_header_id + "&invoice_header_id=" + record.invoice_header_id + "&customer_id=" + record.customer_id}
        >
          {text}
        </Link>
      ),
    },
    {
      title: 'RA# of Pending IR',
      dataIndex: 'return_header_no',
      key: 'return_header_no',
      width: 130,
    },
    {
      title: 'Date',
      width: 80,
      render: (text, record) => {
        return <>{moment(record.invoice_date).format("MM-DD-YY")}</>
      }
    },
    {
      children: [
        {
          title: 'Infant',
          dataIndex: 'Infant',
          key: 'Infant',
          width: 50,
          children: [
            {
              title: 'T-Jacket',
              dataIndex: 'stage',
              key: 'stage',
              width: 70,
              children: [
                {
                  title: 'Shirt',
                  dataIndex: 'stage',
                  key: 'stage',
                  width: 50,
                  children: [
                    {
                      title: 'Y-Adult',
                      dataIndex: 'stage',
                      key: 'stage',
                      width: 50,
                      children: [
                        {
                          title: 'W-Plus',
                          dataIndex: 'stage',
                          key: 'stage',
                          width: 50,
                          children: [
                            {
                              title: 'Kids',
                              dataIndex: 'stage',
                              key: 'stage',
                              width: 50,
                              children: [
                                {
                                  title: 'Men',
                                  dataIndex: 'stage',
                                  key: 'stage',
                                  width: 50,
                                  children: [
                                    {
                                      title: 'Women',
                                      dataIndex: 'stage',
                                      key: 'stage',
                                      width: 70,
                                    },
                                  ],
                                },
                              ],
                            }
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ]
        },
        {
          title: '3m',
          align: 'center',
          dataIndex: 'size1qty1',
          key: 'size1qty1',
          width: 50,
          children: [
            {
              title: '"2/3"',
              align: 'center',
              dataIndex: 'size1qty1',
              key: 'size1qty1',
              width: 55,
              children: [
                {
                  title: 'XS',
                  dataIndex: 'size1qty1',
                  key: 'size1qty1',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '00',
                      dataIndex: 'size1qty1',
                      key: 'size1qty1',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '10W',
                          dataIndex: 'size1qty1',
                          key: 'size1qty1',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '2',
                              dataIndex: 'size1qty1',
                              key: 'size1qty1',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '27',
                                  dataIndex: 'size1qty1',
                                  key: 'size1qty1',
                                  align: 'center',
                                  width: 50,
                                  children: [
                                    {
                                      title: '23',
                                      dataIndex: 'size1qty1',
                                      key: 'size1qty1',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '6m',
          align: 'center',
          width: 50,
          children: [
            {
              title: '"4/5"',
              align: 'center',
              dataIndex: 'size1qty2',
              key: 'size1qty2',
              width: 50,
              children: [
                {
                  title: 'S',
                  align: 'center',
                  dataIndex: 'size1qty2',
                  key: 'size1qty2',
                  width: 55,
                  children: [
                    {
                      title: '0',
                      align: 'center',
                      dataIndex: 'size1qty2',
                      key: 'size1qty2',
                      width: 50,
                      children: [
                        {
                          title: '12W',
                          align: 'center',
                          dataIndex: 'size1qty2',
                          key: 'size1qty2',
                          width: 50,
                          children: [
                            {
                              title: '3',
                              align: 'center',
                              dataIndex: 'size1qty2',
                              key: 'size1qty2',
                              width: 50,
                              children: [
                                {
                                  title: '28',
                                  align: 'center',
                                  dataIndex: 'size1qty2',
                                  key: 'size1qty2',
                                  width: 50,
                                  children: [
                                    {
                                      title: '24',
                                      align: 'center',
                                      dataIndex: 'size1qty2',
                                      key: 'size1qty2',
                                      width: 50,
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '12m',
          align: 'center',
          width: 50,
          children: [
            {
              title: '"6/6X"',
              dataIndex: 'size1qty3',
              key: 'size1qty3',
              align: 'center',
              width: 60,
              children: [
                {
                  title: 'M',
                  dataIndex: 'size1qty3',
                  key: 'size1qty3',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '1',
                      dataIndex: 'size1qty3',
                      key: 'size1qty3',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '14W',
                          dataIndex: 'size1qty3',
                          key: 'size1qty3',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '4',
                              dataIndex: 'size1qty3',
                              key: 'size1qty3',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '29',
                                  dataIndex: 'size1qty3',
                                  key: 'size1qty3',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '25',
                                      dataIndex: 'size1qty3',
                                      key: 'size1qty3',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '18m',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty4',
              key: 'size1qty4',
              width: 50,
              align: 'center',
              children: [
                {
                  title: 'L',
                  dataIndex: 'size1qty4',
                  key: 'size1qty4',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '2',
                      dataIndex: 'size1qty4',
                      key: 'size1qty4',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '16W',
                          dataIndex: 'size1qty4',
                          key: 'size1qty4',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '5',
                              dataIndex: 'size1qty4',
                              key: 'size1qty4',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '30',
                                  dataIndex: 'size1qty4',
                                  key: 'size1qty4',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '26',
                                      dataIndex: 'size1qty4',
                                      key: 'size1qty4',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '24m',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty5',
              key: 'size1qty5',
              width: 50,
              align: 'center',
              children: [
                {
                  title: 'XL',
                  dataIndex: 'size1qty5',
                  key: 'size1qty5',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '3',
                      dataIndex: 'size1qty5',
                      key: 'size1qty5',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '18W',
                          dataIndex: 'size1qty5',
                          key: 'size1qty5',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '6',
                              dataIndex: 'size1qty5',
                              key: 'size1qty5',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '31',
                                  dataIndex: 'size1qty5',
                                  key: 'size1qty5',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '27',
                                      dataIndex: 'size1qty5',
                                      key: 'size1qty5',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty6',
              key: 'size1qty6',
              width: 50,
              align: 'center',

              children: [
                {
                  title: '1XL',
                  dataIndex: 'size1qty6',
                  key: 'size1qty6',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '4',
                      dataIndex: 'size1qty6',
                      key: 'size1qty6',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '20W',
                          dataIndex: 'size1qty6',
                          key: 'size1qty6',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '6x',
                              dataIndex: 'size1qty6',
                              key: 'size1qty6',
                              width: 50,
                              align: 'center',

                              children: [
                                {
                                  title: '32',
                                  dataIndex: 'size1qty6',
                                  key: 'size1qty6',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '28',
                                      dataIndex: 'size1qty6',
                                      key: 'size1qty6',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty7',
              key: 'size1qty7',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '2XL',
                  dataIndex: 'size1qty7',
                  key: 'size1qty7',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '5',
                      dataIndex: 'size1qty7',
                      key: 'size1qty7',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '22W',
                          dataIndex: 'size1qty7',
                          key: 'size1qty7',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '7',
                              dataIndex: 'size1qty7',
                              key: 'size1qty7',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '33',
                                  dataIndex: 'size1qty7',
                                  key: 'size1qty7',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '29',
                                      dataIndex: 'size1qty7',
                                      key: 'size1qty7',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty8',
              key: 'size1qty8',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '3XL',
                  dataIndex: 'size1qty8',
                  key: 'size1qty8',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '6',
                      dataIndex: 'size1qty8',
                      key: 'size1qty8',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '24W',
                          dataIndex: 'size1qty8',
                          key: 'size1qty8',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '7x',
                              dataIndex: 'size1qty8',
                              key: 'size1qty8',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '34',
                                  dataIndex: 'size1qty8',
                                  key: 'size1qty8',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '30',
                                      dataIndex: 'size1qty8',
                                      key: 'size1qty8',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty9',
              key: 'size1qty9',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty9',
                  key: 'size1qty9',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '7',
                      dataIndex: 'size1qty9',
                      key: 'size1qty9',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '26W',
                          dataIndex: 'size1qty9',
                          key: 'size1qty9',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '8',
                              dataIndex: 'size1qty9',
                              key: 'size1qty9',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '35',
                                  dataIndex: 'size1qty9',
                                  key: 'size1qty9',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '31',
                                      dataIndex: 'size1qty9',
                                      key: 'size1qty9',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty10',
              key: 'size1qty10',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty10',
                  key: 'size1qty10',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '8',
                      dataIndex: 'size1qty10',
                      key: 'size1qty10',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '28W',
                          dataIndex: 'size1qty10',
                          key: 'size1qty10',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '10',
                              dataIndex: 'size1qty10',
                              key: 'size1qty10',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '36',
                                  dataIndex: 'size1qty10',
                                  key: 'size1qty10',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '32',
                                      dataIndex: 'size1qty10',
                                      key: 'size1qty10',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty11',
              key: 'size1qty11',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty11',
                  key: 'size1qty11',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '9',
                      dataIndex: 'size1qty11',
                      key: 'size1qty11',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '30W',
                          dataIndex: 'size1qty11',
                          key: 'size1qty11',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '12',
                              dataIndex: 'size1qty11',
                              key: 'size1qty11',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '38',
                                  dataIndex: 'size1qty11',
                                  key: 'size1qty11',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '33',
                                      dataIndex: 'size1qty11',
                                      key: 'size1qty11',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty12',
              key: 'size1qty12',
              width: 50,
              align: 'center',

              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty12',
                  key: 'size1qty12',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '10',
                      dataIndex: 'size1qty12',
                      key: 'size1qty12',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '32W',
                          dataIndex: 'size1qty12',
                          key: 'size1qty12',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '14',
                              dataIndex: 'size1qty12',
                              key: 'size1qty12',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '40',
                                  dataIndex: 'size1qty12',
                                  key: 'size1qty12',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '34',
                                      dataIndex: 'size1qty12',
                                      key: 'size1qty12',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty13',
              key: 'size1qty13',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty13',
                  key: 'size1qty13',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '-',
                      dataIndex: 'size1qty13',
                      key: 'size1qty13',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '-',
                          dataIndex: 'size1qty13',
                          key: 'size1qty13',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '16',
                              dataIndex: 'size1qty13',
                              key: 'size1qty13',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '42',
                                  dataIndex: 'size1qty13',
                                  key: 'size1qty13',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '35',
                                      dataIndex: 'size1qty13',
                                      key: 'size1qty13',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty14',
              key: 'size1qty14',
              width: 50,
              align: 'center',

              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty14',
                  key: 'size1qty14',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '-',
                      dataIndex: 'size1qty14',
                      key: 'size1qty14',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '-',
                          dataIndex: 'size1qty14',
                          key: 'size1qty14',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '18',
                              dataIndex: 'size1qty14',
                              key: 'size1qty14',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '44',
                                  dataIndex: 'size1qty14',
                                  key: 'size1qty14',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '36',
                                      dataIndex: 'size1qty14',
                                      key: 'size1qty14',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty15',
              key: 'size1qty15',
              width: 50,
              align: 'center',

              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty15',
                  key: 'size1qty15',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '-',
                      dataIndex: 'size1qty15',
                      key: 'size1qty15',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '-',
                          dataIndex: 'size1qty15',
                          key: 'size1qty15',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '20',
                              dataIndex: 'size1qty15',
                              key: 'size1qty15',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '46',
                                  dataIndex: 'size1qty15',
                                  key: 'size1qty15',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '37',
                                      dataIndex: 'size1qty15',
                                      key: 'size1qty15',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: '-',
          align: 'center',
          width: 50,
          children: [
            {
              title: '-',
              dataIndex: 'size1qty16',
              key: 'size1qty16',
              width: 50,
              align: 'center',
              children: [
                {
                  title: '-',
                  dataIndex: 'size1qty16',
                  key: 'size1qty16',
                  width: 50,
                  align: 'center',
                  children: [
                    {
                      title: '-',
                      dataIndex: 'size1qty16',
                      key: 'size1qty16',
                      width: 50,
                      align: 'center',
                      children: [
                        {
                          title: '-',
                          dataIndex: 'size1qty16',
                          key: 'size1qty16',
                          width: 50,
                          align: 'center',
                          children: [
                            {
                              title: '-',
                              dataIndex: 'size1qty16',
                              key: 'size1qty16',
                              width: 50,
                              align: 'center',
                              children: [
                                {
                                  title: '48',
                                  dataIndex: 'size1qty16',
                                  key: 'size1qty16',
                                  width: 50,
                                  align: 'center',
                                  children: [
                                    {
                                      title: '38',
                                      dataIndex: 'size1qty16',
                                      key: 'size1qty16',
                                      width: 50,
                                      align: 'center',
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: 'Location',
      dataIndex: 'location_name',
      key: 'location_name',
      width: 150,
    },
    {
      title: 'Store No.',
      dataIndex: 'store_id',
      key: 'store_id',
      width: 150,
    },

  ];

  const onFinish = async () => {
    await form.validateFields().then((values) => {
      setCreditOpenDetailList([]);
      setLoading(true)
      dispatch(getCreditOpenInvoice(token, values)).then((res) => {
        setToogle(true);
        setLoading(false)
        setCreditOpenDetailList(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    })
  }

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "SKU": v.parent_item_code,
          "Inseasm": v.inseam,
          "Customer": v.customer_name,
          "Billing Addressee": v.billing_addressee,
          "Billing City": v.billing_city,
          "Shipping City": v.shipping_city,
          "Invoice #": v.invoice_header_no,
          "RA# of Pending IR": v.return_header_no,
          "Date": moment(v.invoice_date).format("MM-DD-YYYY"),
          "Stage": v.stage,
          "=\"\"2/3\"\"&CHAR(10)&\"\"XS\"\"&CHAR(10)&\"\"2\"\"&CHAR(10)&\"\"27\"\"&CHAR(10)&\"\"23\"\"": v.size1qty1,
          "=\"\"4/5\"\"&CHAR(10)&\"\"S\"\"&CHAR(10)&\"\"3\"\"&CHAR(10)&\"\"28\"\"&CHAR(10)&\"\"24\"\"": v.size1qty2,
          "=\"\"6/6X\"\"&CHAR(10)&\"\"M\"\"&CHAR(10)&\"\"4\"\"&CHAR(10)&\"\"29\"\"&CHAR(10)&\"\"25\"\"": v.size1qty3,
          "=\"\"-\"\"&CHAR(10)&\"\"L\"\"&CHAR(10)&\"\"5\"\"&CHAR(10)&\"\"30\"\"&CHAR(10)&\"\"26\"\"": v.size1qty4,
          "=\"\"-\"\"&CHAR(10)&\"\"XL\"\"&CHAR(10)&\"\"6\"\"&CHAR(10)&\"\"31\"\"&CHAR(10)&\"\"27\"\"": v.size1qty5,
          "=\"\"-\"\"&CHAR(10)&\"\"1XL\"\"&CHAR(10)&\"\"6x\"\"&CHAR(10)&\"\"32\"\"&CHAR(10)&\"\"28\"\"": v.size1qty6,
          "=\"\"-\"\"&CHAR(10)&\"\"2XL\"\"&CHAR(10)&\"\"7\"\"&CHAR(10)&\"\"33\"\"&CHAR(10)&\"\"29\"\"": v.size1qty7,
          "=\"\"-\"\"&CHAR(10)&\"\"3XL\"\"&CHAR(10)&\"\"7x\"\"&CHAR(10)&\"\"34\"\"&CHAR(10)&\"\"30\"\"": v.size1qty8,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"8\"\"&CHAR(10)&\"\"35\"\"&CHAR(10)&\"\"31\"\"": v.size1qty9,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"10\"\"&CHAR(10)&\"\"36\"\"&CHAR(10)&\"\"32\"\"": v.size1qty10,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"12\"\"&CHAR(10)&\"\"38\"\"&CHAR(10)&\"\"33\"\"": v.size1qty11,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"14\"\"&CHAR(10)&\"\"40\"\"&CHAR(10)&\"\"34\"\"": v.size1qty12,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"16\"\"&CHAR(10)&\"\"42\"\"&CHAR(10)&\"\"35\"\"": v.size1qty13,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"18\"\"&CHAR(10)&\"\"44\"\"&CHAR(10)&\"\"36\"\"": v.size1qty14,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"20\"\"&CHAR(10)&\"\"46\"\"&CHAR(10)&\"\"37\"\"": v.size1qty15,
          "=\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"-\"\"&CHAR(10)&\"\"48\"\"&CHAR(10)&\"\"38\"\"": v.size1qty16,
          "Location": v.location_name,
          "Store No.": v.store_id,
        };

      })
    )
  }

  return (
    <div className="styleContainer" >
      <div className="styleBody h-100">
        <PageHeader
          title={"Credit Open-Invoice"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-0">
              <Form onFinish={onFinish} form={form} name="control-hooks">
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div >
                          <Form.Item
                            name="customer"
                            label="Customer"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              size='small'
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div >
                          <Form.Item
                            name="billing_addressee"
                            label="Billing addressee"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              size='small'
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div className="relative">
                          <Form.Item
                            name="from_date"
                            label="From Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().startOf('year')}

                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}


                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            name="to_date"
                            label="To Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().endOf('year')}

                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div >
                          <Form.Item
                            name="parent_sku"
                            label="Parent SKU #"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              size='small'
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="firstSectionRo">
                        <Form.Item
                          name="location"
                          label="Location"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size="small"
                            showSearch
                            optionFilterProp="children"
                            autoComplete={"nope"}
                            loading={adminLocation.loading}
                            filterSort={(optionA, optionB) =>
                              optionB?.value !== null ?
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                            }
                          >
                            <Option value={null}>All</Option>
                            {
                              adminLocation?.payload?.data.map((val, index) => {
                                return (
                                  <Option key={index} value={val.location_id}>
                                    {val.location_name}
                                  </Option>
                                )
                              })
                            }

                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                  </Brow>
                </div>
              </Form>
              <Button
                htmlType="submit"
                type="primary"
                className="submit-btn-btm "
                onClick={onFinish}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        {
          loading ? (
            <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin size='large' />
            </div>
          ) : (creditOpenDetailList.length > 0 ? (
            < Table
              title={() =>
                <CSVLink
                  filename={`Credit-Open-Invoice-Detail-Report-${moment().format("MM-DD-YY")}`}
                  data={excelData}
                  onClick={() => {

                  }}
                >
                  Download Excel
                </CSVLink>
              }
              ref={tableRef}
              key={creditOpenDetailList?.length}
              columns={BDCols}
              loading={creditOpenInvoice?.loading}
              dataSource={indexedData} // ✅ Use this instead of raw data
              rowKey={(record, index) => `${record.invoice_header_id}-${index}`}
              rowClassName={(record) =>
                Number(record.return_header_no) > 0 ? 'bold-row' : ''
              }
              size="small"
              bordered
              scroll={{
                x: 'calc(400px + 80%)',
                y: 450,
              }}
              pagination={{ pageSize: 1000 }}
              summary={(pageData) => {
                const filteredPageData = pageData.filter(row => row.return_header_no === 0);

                const sumSize = (key) => filteredPageData.reduce((total, item) => total + parseFloat(item[key] || 0), 0);
                const Size1 = sumSize('size1qty1');
                const Size2 = sumSize('size1qty2');
                const Size3 = sumSize('size1qty3');
                const Size4 = sumSize('size1qty4');
                const Size5 = sumSize('size1qty5');
                const Size6 = sumSize('size1qty6');
                const Size7 = sumSize('size1qty7');
                const Size8 = sumSize('size1qty8');
                const Size9 = sumSize('size1qty9');
                const Size10 = sumSize('size1qty10');
                const Size11 = sumSize('size1qty11');
                const Size12 = sumSize('size1qty12');
                const Size13 = sumSize('size1qty13');
                const Size14 = sumSize('size1qty14');
                const Size15 = sumSize('size1qty15');
                const Size16 = sumSize('size1qty16');
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size1.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size2.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size3.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size4.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size5.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size6.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size7.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size8.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size9.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size10.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size11.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size12.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size13.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size14.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size15.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p className="totalquantity aligntext">
                          {Size16.toLocaleString("en-US")}
                        </p>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          ) : <div
            style={{
              backgroundColor: "#CCCCCC",
              borderWidth: "1pt",
              borderStyle: "Dashed",
              fontWeight: "bold",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No record(s)
          </div>
          )
        }
      </div>
    </div >
  )
}
export default CreditOpenInvoicedetailReport;